import { addEventListeners } from './addEventListeners';

export { addEventListeners };
